module.exports = __webpack_public_path__ + "img/气21.2165e867.png";